import { render, staticRenderFns } from "./LinkMovie.vue?vue&type=template&id=5b93206b&scoped=true&"
import script from "./LinkMovie.vue?vue&type=script&lang=js&"
export * from "./LinkMovie.vue?vue&type=script&lang=js&"
import style0 from "./LinkMovie.vue?vue&type=style&index=0&id=5b93206b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b93206b",
  null
  
)

component.options.__file = "LinkMovie.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTimePicker } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDatePicker,
  VDialog,
  VDivider,
  VForm,
  VIcon,
  VMenu,
  VSelect,
  VSpacer,
  VTextField,
  VTimePicker,
})
